export default "__VITE_ASSET__CoRZPiO6__"